import React, { useState} from 'react';
import AppVersionItem from './AppVersionItem'


function GroupAppVersionList(props){
  // map the data to JSX
  const applist = props.data.apps.map(a => (
      <AppVersionItem app={a} group={props.data.group} postGroupVersion={props.postGroupVersion} key={a.id} />
  ))

 return (
   <>
     {applist}
   </>
 )
}

export default GroupAppVersionList;